export default {
  name: 'file.stopped_sharing',
  background (payload, context) {
    const file = this.state.file
    let reload = false

    if (payload.file_id === file.record.id_file) reload = true
    else if (file.record.ancestors) {
      for (let ancestor of file.record.ancestors) {
        if (payload.file_id === ancestor.id_file) reload = true
      }
    }

    if (reload) {
      location.reload()
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/notifications/notifications/FileStoppedSharing.js